var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.628 22.627"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 32606",
    opacity: 0.5,
    fill: "none",
    stroke: "#8d8c8c",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3112",
    d: "M21.92.707L.707 21.92"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3113",
    d: "M21.92 21.92L.707.707"
  }))));
}

export default __webpack_public_path__ + "b361369eb23398966e4eae66c3bebc1f.svg";
export { SvgCloseGrey as ReactComponent };